import type { WhitelabelDashboardResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { whitelabelKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getWhitelabelDashboard(): Promise<WhitelabelDashboardResponse> {
  return apiClient.url("/whitelabel/dashboard").get().json();
}

export function useWhitelabelDashboard(): UseQueryResult<
  WhitelabelDashboardResponse,
  Error
> {
  return useQuery({
    queryFn: getWhitelabelDashboard,
    queryKey: whitelabelKeys.dashboard(),
    staleTime: 60 * 1000,
  });
}
